import { Button } from '@cian/ui-kit/button';
import { TButtonTheme } from '@cian/ui-kit/button/types';
import { IconActionCompareAdd16, IconActionCompareAdded16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import {
  ADD_TO_COMPARE_LABEL,
  ADD_TO_COMPARE_TEXT,
  COMPARE_BUTTON_DATA_MARK,
  REMOVE_FROM_COMPARE_LABEL,
  REMOVE_FROM_COMPARE_TEXT,
} from './constants';

interface ICompareButtonControlProps {
  buttonTheme?: TButtonTheme;
  isAdded: boolean;
  onClick(): void;
}

export function CompareButtonControl({ buttonTheme = 'main_secondary', isAdded, onClick }: ICompareButtonControlProps) {
  return (
    <Button
      beforeIcon={
        isAdded ? (
          <IconActionCompareAdded16 color="icon-main-default" />
        ) : (
          <IconActionCompareAdd16 color="icon-main-default" />
        )
      }
      theme={buttonTheme}
      size="XS"
      onClick={onClick}
      data-mark={COMPARE_BUTTON_DATA_MARK}
      data-testid="NewbuildingCompareButton"
      aria-label={isAdded ? REMOVE_FROM_COMPARE_LABEL : ADD_TO_COMPARE_LABEL}
    >
      {isAdded ? REMOVE_FROM_COMPARE_TEXT : ADD_TO_COMPARE_TEXT}
    </Button>
  );
}
